const theme = {
  color: {
    text: "rgba(0,0,0,0.9)",
    textInverted: "#fff",
    textDisplay: "#222",
    textDisabled: "rgba(0,0,0,0.5)",
    annotation: "rgba(0,0,0,0.75)",
    textFooter: "rgba(0, 0, 0, 0.55)",
    background: "#f7f7f7",
    backgroundSuperLight: "rgba(160, 160, 160, 0.04)", // #FBFBFB
    backgroundAttention: "#F2F7F9",
    backgroundAttentionLight: "#f8fafc",
    backgroundKickstarterNewsletter: "#E9E9E9",
    backgroundLightGradient:
      "linear-gradient(180deg, #f2f7f9 0%, #f2f7f9 100%)",
    backgroundInverted: "#fff",
    backgroundDark: "#1c1c1c",
    border: "#dadada",
    borderLight: "rgba(218, 218, 218, 0.5)", // #EDEDED
    button: "#3B3F42",
    buttonActive: "#1a1e21",
    buttonSuccess: "#6D9BBC",
    buttonDisabled: "#fbfbfb",
    invertedButtonColor: "#3b3f42",
    kickstarterBackgroundPrimary: "#F7F7F7",
    kickstarterButton: "#EF904C",
    kickstarterButtonHover: "#000000",

    notification: "#40749a",
    chartCircleFill: "#d7dbe4",
    chartCircleHover: "#a8b8c0",
    chartCircleActive: "#000000",
    hoverIcon: "#517B98",
    hoverIconBackground: "#a8b8c0",
    hoverPlayerArrow: "#FFFFFF",
    lightShadow: "rgba(0, 0, 0, 0.06)", // #F0F0F0
    link: "#40749A",
    linkHover: "#527B99",
    error: "#B74B4B",
    success: "#7FA781",
    inputBackground: "white",
    inputDisabledBackground: "rgba(239, 239, 239, 0.3)",
    tag: "#517B98",
    newsletterAgreement: "rgba(0, 0, 0, 0.45)",
    placeholder: "rgba(133,139,140, 0.55)",
    arrowBackground: "rgba(255, 255, 255, 0.33)",
    arrowBackgroundDark: "#f0f0f0",
    arrowBackgroundLight: "#f8f8f8",
    arrowFillLight: "#c6c6c6",
    arrowFillDark: "#8d8d8d",
    arrowFillInverted: "#ffffff",
    scrollArrowColor: "#A8B8C0",
    tooltipBoxShadow: "rgba(225, 234, 238, 0.6)",
    kickstarter: "#D7558E",
    kickstarterActive: "#f15d9e",
    removeIconStroke: "#afb2b4",
    removeIconStrokeHover: "#f1f1f1",
    inputBorder: "#ebebec",
    inputBorderActive: "#3b3f42",
    commerceBorder: "#e5e5e5",
    commerceShadow: "rgba(46, 53, 57, 0.15)",
    commerceLightShadow: "rgba(0,0,0,0.11)",
    commerceBlue: "rgb(109, 155, 188)",
    commerceBlueTransparent: "rgba(109, 155, 188, 0.75)",
    removeIcon: "#d1d1d1",
    inputPlaceholder: "#a9a9a9",
    dropdownShadow: "rgba(46,53,57,0.08)", // #efefef
    selectActiveOption: "#f1f1f1",
    productLabelText: "#000000",
    promoBarlink: "#000000",
    discount: "#308234",
    info: "#737373",
    dot: {
      active: "#6D9BBC",
      inactive: "#D7E0E9",
      hover: "#96a6b6",
    },
    flash: {
      error: "#B74B4B",
      info: "#FBFBFB",
      warning: "#f7ebdf",
      success: "#FFFFFF",
    },
  },
  size: {
    borderRadius: "5px",
    borderRadiusSmall: "3px",
    borderRadiusSmaller: "2px",
    /* FIXME: remove probably duplicated values & check usage */
    headerHeightMobile: 60,
    headerHeightDesktop: 90,
    headerMobile: 60,
    headerTablet: 90 + 15,
    headerDesktop: 90 + 60,
    secondaryHeaderMobile: 60,
    secondaryHeaderDesktop: 60,
  },
  breakpoint: {
    mobileSmall: 320,
    mobile: 375,
    mobileHorizontal: 640,
    tablet: 768,
    tabletHorizontal: 960,
    desktop: 1160,
    desktopMedium: 1260,
  },
  font: {
    display:
      "Facto, Arial, Helvetica, Gill Sans, Lucida, Helvetica Narrow, sans-serif",
    basic:
      "Montserrat, Arial, Helvetica, Gill Sans, Lucida, Helvetica Narrow, sans-serif",
  },
  zIndexes: {
    midLayer: 1,
    frontLayer: 2,
    headerLayer: 10,
    modalUnderHeaderLayer: 8,
    modalTopLayer: 1000,
  },
}

export type Theme = typeof theme

export default theme
